import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  Bar,
} from "recharts";

const Chart = ({ plot }) => (
  <div className="w-full h-[70vh]">
    <ResponsiveContainer width="100%" height="100%">
      <BarChart width={500} height={300} data={plot} barSize={20}>
        <XAxis dataKey="name" scale="point" allowDuplicatedCategory={false} />
        <YAxis allowDuplicatedCategory={false} />
        <Tooltip />
        <Legend />
        <CartesianGrid strokeDasharray="3 3" />
        {plot.map(entry => (
          <Bar
            dataKey={entry.dataKey}
            key={entry.name}
            data={entry.data}
            fill={entry.fill}
            background={{ fill: "#eee" }}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export default Chart;
